<template>
  <ix-router-link class="ktag" :to="url" v-on:click.native="$event.stopImmediatePropagation();handleNav()">{{ trimmed }}</ix-router-link>
</template>

<script>
export default {
  props: {
    keyword: String,
    trans: String
  },
  computed: {
    url () {
      return '/search/' + encodeURIComponent(this.keyword)
    },
    trimmed () {
      let kw = this.trans || this.keyword
      if(kw.indexOf('.') >= 0) {
        return kw.split('.').pop()
      }
      return kw
    }
  },
  methods: {
    handleNav() {
      console.log('handing nav for', this.keyword)
    }
  }
}
</script>
<style scoped>
.ktag{
  border:1px solid #8b6f4b;
  display:inline-block;
  border-radius:3px;
  padding:3px 5px;
  font-size:14px;
  color:#8b6f4b;
  margin-right:6px;
  margin-bottom:6px;
  text-transform:lowercase;
}

.ktag:hover{
  color:#fff;
  background-color:#8b6f4b;
}
</style>

